import React from 'react'

import { H4 } from 'src/styled'

interface ContactTypeProps {
  isPrimary: boolean
}

const ContactType: React.FC<ContactTypeProps> = props => {
  const { isPrimary } = props

  return <>{!isPrimary && <H4>Secondary Contact</H4>}</>
}

export default ContactType
